import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import {
  FlexContainer,
  Heading1,
  Heading2,
  LI,
  Section,
  SectionArticle,
  UL,
  useLocales,
} from "@crescentapplications/react-ui";

export default function Volunteering() {
  const l = useLocales();

  return (
    <Section bgColor="frame" id="volunteering" padding="lg">
      <FlexContainer direction="column" gap="xl" fullWidth>
        <Heading1>{l(AhmadAhmadLocales.volunteering)}</Heading1>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.currently)}</Heading2>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.currently1a)}{" "}
              <a
                href="https://www.colorado.edu"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.currently1link)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.previously)}</Heading2>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.previously1A)}{" "}
              <a
                href="https://www.colorado.edu"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.previously1link)}
              </a>{" "}
              {l(AhmadAhmadLocales.previously1B)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.previouslyCcA)}{" "}
              <a
                href="https://www.gpngreatlife.com/clubs"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.previouslyCcLink)}
              </a>{" "}
              {l(AhmadAhmadLocales.previouslyCcB)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.previously3a)}{" "}
              <a
                href="https://www.crescentfoodbank.org/"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.previously3b)}
              </a>{" "}
              {l(AhmadAhmadLocales.previously3c)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.previously6a)}{" "}
              <a
                href="http://www.upliftcharity.org/"
                target="_blank"
                rel="noreferrer"
              >
                <span className="english-font">
                  {l(AhmadAhmadLocales.previously6b)}
                </span>
              </a>{" "}
              {l(AhmadAhmadLocales.previously6c)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.previously7a)}{" "}
              <a href="https://efb.eg/" target="_blank" rel="noreferrer">
                {l(AhmadAhmadLocales.previously7b)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>
        </SectionArticle>
      </FlexContainer>
    </Section>
  );
}
